import React from 'react'
import Moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ItemSearch from '../../../../Shared/ItemSearch/ItemSearch'

import './History.css'

const HIST_PAGE_SZE = 25

var Spinner = require('react-spinkit');

class HistoryPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: Moment().add(-1, 'months')
        }

        this.changeDate = this.changeDate.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.startDate !== prevState.startDate) {
            this.props.newDateSearch(Moment(this.state.startDate).format('YYYY-MM-DD'));
        }
    }

    changeDate(date) {
        this.setState({
            startDate: date
        });
    }

    render() {
        return (
            <div className="historyPanel">
                <div className="row">
                    <div className="col-md-12 header">
                        <div className="col-md-3">
                            <p>Pull changes from:</p>
                            <DatePicker
                                id="history-date"
                                onChange={this.changeDate}
                                selected={Moment(this.state.startDate).toDate()}
                            />
                        </div>
                        <div className="col-md-5">
                            <p>User:</p>
                            <ItemSearch id="history_user" items={this.props.items} newSearch={this.props.newUserSearch} />                      
                        </div>
                        <div className="col-md-4 pages">
                            <span id="pages">{this.props.user.history.totalRecords} Results (Viewing 1-{this.props.page * HIST_PAGE_SZE >= this.props.user.history.totalRecords ? this.props.user.history.totalRecords : this.props.page * HIST_PAGE_SZE} of {this.props.user.history.totalRecords})</span>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 spinner pull-right">
                        {
                            this.props.user.updatingHistory ?
                                <Spinner name='line-spin-fade-loader' />
                            :
                                null
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <table className="history table table-striped">
                            <thead>
                                <tr className="head">
                                    <th>Change Date</th>
                                    <th>User</th>
                                    <th>Change Field</th>
                                    <th>From</th>
                                    <th>To</th>
                                </tr>
                            </thead>

                            <tbody>
                            {
                                this.props.user.history.totalRecords ?
                                    this.props.user.history.userChangeHistoryRecords.filter((hist) => { return hist.from != hist.to })
                                    .map((hist, index) => {
                                        return <tr key={index}>
                                            <td>{hist.changeDate}</td>
                                            <td>{hist.user}</td>
                                            <td>{hist.changeField}</td>
                                            <td className="longdata">{hist.from}</td>
                                            <td className="longdata">{hist.to}</td>
                                        </tr>
                                    })
                                : null
                            }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        {
                            this.props.page * HIST_PAGE_SZE < this.props.user.history.totalRecords ?
                                <button id="load" onClick={this.props.loadMore} >Load More</button>
                            :
                                null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default HistoryPanel